module.exports = __webpack_public_path__ + "assets/img/lists.dcc0c6a7.svg";